import { useQuery } from "@tanstack/react-query";
import { SingleSelectDropdown } from "Components/SingleSelectDropdown";
import apiClient from "QueryClient/axiosClient";
import { Flex, Typography } from "antd";
import debounce from "lodash.debounce";
import { useState } from "react";

const fetchCountries = async ({ queryKey }) => {
  const [, search] = queryKey;
  const response = await apiClient.get("/countries", {
    params: { q: search },
  });
  return response.data;
};

export const Country = ({ country, setCountry }) => {
  const { Title } = Typography;
  const [search, setSearch] = useState("");
  const { data, error, isLoading } = useQuery(
    ["/countries", search],
    fetchCountries
  );
  const debounceSearch = debounce((value) => {
    setSearch(value);
  }, 500);
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>
        Student's current country
      </Title>
      <SingleSelectDropdown
        options={
          isLoading || error
            ? [{ label: "loading", value: "loading" }]
            : data?.data?.map((country) => ({
                label: country.name,
                value: country.name,
              }))
        }
        placeholder="Select Country"
        loading={false}
        onChange={(value) => {
          setCountry(value);
        }}
        onSearch={debounceSearch}
        value={country}
      />
    </Flex>
  );
};
